<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">

        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">people</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">جميع طلبات السحب</div>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">ادارة طلبات السحب</div>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="12" md="4" class="text-center py-1" FILTER>
                        <AccountsSearch
                          @searchAccounts="searchAccounts"
                          :search_object="search_object"
                          :loading="loading"
                        />
                      </v-col>

                      <v-col class="align-center justify-center text-center" cols="12" md="4">
                        <v-switch hide-details inset :class="`${arabic ? 'arFont' : 'enFont'} mt-0`"
                          label="بانتظار المراجعة" v-model="onlyPending" @change="filterResource()">
                        </v-switch>
                      </v-col>

                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                            <Paging :resourceSettings="resourceSettings" :resource="resource"
                              @loadResource="loadResource" @pageByNumber="pageByNumber" />
                          </v-col>
                          <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                            <v-expansion-panels focusable>
                              <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-' + i"
                                style="cursor:pointer;">
                                <v-expansion-panel-header>
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" md="3"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 font-weight-bold`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">
                                            <div :class="`${arabic ? 'arFont' : 'enFont'}`"
                                              style="font-weight:bold;font-size:11px;">
                                              طريقة الدفع
                                            </div>
                                            <div>
                                              {{ paymentMethods.filter(x => x.slug == r.type)[0].en }}
                                            </div>
                                            <div v-if="ifPhoneNumber(r.type)">
                                              {{ r.phone_number }}
                                            </div>
                                            <div v-if="r.type == 'tiktok' || r.type == 'snapchat' || r.type == 'facebook'">
                                              <div>{{ r.payment_account }}</div>
                                            </div>
                                            <div v-if="r.type == 'paypal' || r.type == 'payoneer'">
                                              {{ r.paypal_email }}
                                            </div>
                                            <div v-if="r.type == 'usdt'">
                                                {{ r.payment_account }}
                                              </div>
                                            <div v-if="r.type == 'cash_plus'">
                                              <div>{{ r.official_name }}</div>
                                              <div>{{ r.city }}</div>
                                            </div>
                                            <div v-if="r.type == 'bank'">
                                              <div>{{ r.bank }}</div>
                                              <div>{{ r.bank_account_name }}</div>
                                              <div>{{ r.iban }}</div>
                                              <div>{{ r.swift }}</div>
                                              <div>{{ r.account_number }}</div>
                                              <div>{{ r.routing_number }}</div>
                                              <div>{{ r.fedwire }}</div>
                                              <div>{{ r.currency }}</div>
                                              <div>{{ r.bank_address }}</div>
                                              <div>{{ r.user_address }}</div>
                                              <div>{{ r.city }}</div>
                                              <div>{{ r.country }}</div>
                                            </div>
                                          </span>
                                        </template>
                                        <div class="text-center">
                                          <div :class="`${arabic ? 'arFont' : 'enFont'}`">تم الطلب:
                                            {{ getFormat(r.created_at) }}</div>
                                          <div :class="`${arabic ? 'arFont' : 'enFont'}`">اخر تحديث:
                                            {{ getFormat(r.updated_at) }}</div>
                                        </div>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" md="3" :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1`">
                                      <div style="font-size:11px;">ACCOUNT: {{ r.account.name }}</div>
                                      <div style="font-size:11px;">ACCOUNT ID:{{ r.account.id }}</div>
                                    </v-col>
                                    <v-col cols="12" md="3"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 adminSwitch text-right`">
                                      <v-switch @change="updateResource(r)" hide-details
                                        :class="`${arabic ? 'arFont' : 'enFont'}`" label="تمت المراجعة"
                                        v-model="r.reviewed"></v-switch>
                                    </v-col>
                                    <v-col cols="12" md="3"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 adminSwitch text-right`">
                                      <v-switch @change="updateResource(r)" hide-details
                                        :class="`${arabic ? 'arFont' : 'enFont'}`" label="تمت الموافقة"
                                        v-model="r.approved"></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-divider class="pb-3"></v-divider>
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" FIELD>
                                      <v-textarea label="ملاحظات" v-model="r.note"
                                        :class="`${arabic ? 'arFont' : 'enFont'}`" outlined hide-details
                                        dense></v-textarea>
                                    </v-col>
                                    <v-col cols="12" md="12"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-1 adminSwitch text-left`">
                                      <v-btn color="success" block text @click="updateResource(r)">
                                        <v-icon left>save</v-icon>
                                        <span>تحديث</span>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>

                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>

                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountsSearch from '@/components/AccountsSearch';
import Paging from '@/components/Paging';
import { format } from 'timeago.js';

export default {
  components: { Paging, AccountsSearch },
  data() {
    return {
      loading: false,
      dialog: false,
      vresource: [],
      resource: [],
      search: null,
      rules: {
        required: (value) => !!value || this.i18n.required,
        email: (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n.valid_email,
      },
      resourceKeys: [

      ],
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
      newResource: {},
      editing: false,
      deleting: false,
      page: null,
      selectedAccount: null,
      onlyPending: true,
      search_object:{}

    };
  },
  methods: {
    async searchAccounts(){
      this.filterResource()
    },
    ifPhoneNumber(method) {
      if (this.$store.state.paymentMethods.filter((x) => x.number).map((x) => x.slug).includes(method)) {
        return true;
      }
      return false;
    },
    getFormat(d) {
      return format(d);
    },
    filterObject(item, queryText, itemText) {
      const v = Object.values(item).filter((x) => typeof x === 'string');
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (itemText && typeof itemText === 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true;
      return a;
    },
    clipboardSuccessHandler() {
      this.$emit('snackbarNotification', 'Copied', 'success');
    },
    clipboardErrorHandler() {
      this.$emit('snackbarNotification', 'Failed', 'error');
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        this.page = n;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path, page: `?page=${this.page}${this.buildFilter()}` });
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: `${this.$route.path}/search?page=${this.page}`, value: this.search });
        }
        this.loading = false;
      });
    },
    goTo(path) {
      this.$router.push(path).catch((x) => { });
    },
    buildFilter() {
      let filter = '';
      if (this.selectedAccount) {
        filter += `&filter[account_id]=${this.selectedAccount.id}`;
      }
      if (this.onlyPending) {
        filter += '&filter[pending]=true';
      }
      if (this.search_object && this.search_object.search) {
        filter += `&filter[search]=${this.search_object.search}`;
      }
      return filter;
    },
    async filterResource() {
      await this.loadResource();
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: `${this.$route.path}?page=${this.page}${this.buildFilter()}` });
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: `${this.$route.path}/search` + `?page=${this.page}`, value: this.search });
        }
        console.log('paymentMethods res', this.resource);
        this.loading = false;
        res();
      });
    },
    async updateResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        // console.log(r)
        if (r.approved) {
          r.reviewed = true;
        }

        await this.$store.dispatch('putResource', { resource: `${this.$route.path}/${r.id}`, value: r });
        this.loadResource();
        this.loading = false;
      });
    },
    showPannel(v) {
      this[v] = true;
      const all = this.subitems.map((x) => x.value);
      all.filter((x) => x != v).forEach((x) => this[x] = false);
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')];
    },

    accountChangedHandler(accountInfo) {
      this.selectedAccount = accountInfo;
      this.filterResource();
    },
  },
  computed: {
    api() {
      return this.$store.state.settings.apiBase;
    },
    users() {
      const sa = this.$store.state.user && this.$store.state.user.role == 'superadmin';
      // console.log(sa)
      return this.$store.state.users.filter((x) => {
        if (!sa) {
          return x.superior == this.$store.state.user.level;
        } return x;
      });
    },
    site() {
      return this.$store.state.site;
    },
    items() {
      return this.$store.state.menu;
    },
    superAdmin() {
      return this.$store.state.superAdmin;
    },
    isLogin() {
      return this.$store.state.centralLogin;
    },
    language() {
      return this.$store.state.language;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    user() {
      return this.$store.state.user;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true;
    },
    routeTitle() {
      const main = this.$store.state.menu.filter((x) => x.path == this.$route.path);
      const sub = [].concat(...this.$store.state.menu.map((x) => x.subs)).filter((x) => x).filter((x) => x.path == this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      } if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      }
      return '';
    },
    roles() {
      return this.$store.state.userRoles;
    },
    notifications() {
      return this.$store.state.notifications.sort((a, b) => b.timestamp - a.timestamp);
    },
    paymentMethods() {
      return this.$store.state.paymentMethods;
    },
  },
  async created() {
    this.setResourceName();
    await this.loadResource();
  },
};
</script>

<style>

</style>
